import { ReactNode, useMemo } from 'react';
import {
  LINK_PREMIUM_BOTH,
  LINK_PREMIUM_BOTH_DISCOUNT,
  LINK_PREMIUM_FIVE_TOURNAMENTS,
  LINK_PREMIUM_FIVE_TOURNAMENTS_DISCOUNT,
  LINK_PREMIUM_MONTHLY,
  LINK_PREMIUM_MONTHLY_DISCOUNT,
  LINK_PREMIUM_ONE_TOURNAMENT,
  LINK_PREMIUM_ONE_TOURNAMENT_DISCOUNT,
  LINK_PREMIUM_SUMMER,
  LINK_PREMIUM_TEN_TOURNAMENTS,
  LINK_PREMIUM_TEN_TOURNAMENTS_DISCOUNT,
  LINK_PREMIUM_YEARLY,
  LINK_PREMIUM_YEARLY_DISCOUNT,
  PRICE_PREMIUM_FIVE_TOURNAMENTS,
  PRICE_PREMIUM_FIVE_TOURNAMENTS_DISCOUNT,
  PRICE_PREMIUM_MONTHLY,
  PRICE_PREMIUM_MONTHLY_DISCOUNT,
  PRICE_PREMIUM_ONE_TOURNAMENT,
  PRICE_PREMIUM_ONE_TOURNAMENT_DISCOUNT,
  PRICE_PREMIUM_SUMMER,
  PRICE_PREMIUM_TEN_TOURNAMENTS,
  PRICE_PREMIUM_TEN_TOURNAMENTS_DISCOUNT,
  PRICE_PREMIUM_YEARLY,
  PRICE_PREMIUM_YEARLY_DISCOUNT,
} from '@features/chessrussian/customizations/constants';
import { useIsChessRussianStudent } from '@features/chessrussian/customizations/hooks/useIsChessRussianStudent';
import { PremiumLinksCtx, PremiumLinksCtxType } from './PremiumLinksCtx';

type Props = {
  children: ReactNode;
};

export function PremiumLinksProvider({ children }: Props) {
  const { isLoading, isStudent } = useIsChessRussianStudent();

  const ctxValue: PremiumLinksCtxType = useMemo(
    () => ({
      monthlyLink: isStudent
        ? LINK_PREMIUM_MONTHLY_DISCOUNT
        : LINK_PREMIUM_MONTHLY,
      monthlyPrice: isStudent
        ? PRICE_PREMIUM_MONTHLY_DISCOUNT
        : PRICE_PREMIUM_MONTHLY,
      monthlyOldPrice: isStudent ? PRICE_PREMIUM_MONTHLY : undefined,

      yearlyLink: isStudent
        ? LINK_PREMIUM_YEARLY_DISCOUNT
        : LINK_PREMIUM_YEARLY,
      yearlyPrice: isStudent
        ? PRICE_PREMIUM_YEARLY_DISCOUNT
        : PRICE_PREMIUM_YEARLY,
      yearlyOldPrice: isStudent ? PRICE_PREMIUM_YEARLY : undefined,

      summerLink: LINK_PREMIUM_SUMMER,
      summerPrice: PRICE_PREMIUM_SUMMER,

      bothLink: isStudent ? LINK_PREMIUM_BOTH_DISCOUNT : LINK_PREMIUM_BOTH,

      oneTournamentLink: isStudent
        ? LINK_PREMIUM_ONE_TOURNAMENT_DISCOUNT
        : LINK_PREMIUM_ONE_TOURNAMENT,
      oneTournamentPrice: isStudent
        ? PRICE_PREMIUM_ONE_TOURNAMENT_DISCOUNT
        : PRICE_PREMIUM_ONE_TOURNAMENT,
      oneTournamentOldPrice: isStudent
        ? PRICE_PREMIUM_ONE_TOURNAMENT
        : undefined,

      fiveTournamentsLink: isStudent
        ? LINK_PREMIUM_FIVE_TOURNAMENTS_DISCOUNT
        : LINK_PREMIUM_FIVE_TOURNAMENTS,
      fiveTournamentsPrice: isStudent
        ? PRICE_PREMIUM_FIVE_TOURNAMENTS_DISCOUNT
        : PRICE_PREMIUM_FIVE_TOURNAMENTS,
      fiveTournamentsOldPrice: isStudent
        ? PRICE_PREMIUM_FIVE_TOURNAMENTS
        : undefined,

      tenTournamentsLink: isStudent
        ? LINK_PREMIUM_TEN_TOURNAMENTS_DISCOUNT
        : LINK_PREMIUM_TEN_TOURNAMENTS,
      tenTournamentsPrice: isStudent
        ? PRICE_PREMIUM_TEN_TOURNAMENTS_DISCOUNT
        : PRICE_PREMIUM_TEN_TOURNAMENTS,
      tenTournamentsOldPrice: isStudent
        ? PRICE_PREMIUM_TEN_TOURNAMENTS
        : undefined,

      isLoading,
    }),
    [isStudent, isLoading],
  );

  return (
    <PremiumLinksCtx.Provider value={ctxValue}>
      {children}
    </PremiumLinksCtx.Provider>
  );
}
